import preloader from "./preloader";
import {displayFormError} from "./helper";

var profile = function () {
    // Update profile
    $('.profile-update-form').on('submit', function(e){
        e.preventDefault();

        let form = $(this);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        let data = form.serializeArray();

        let formData = new FormData();

        for(let key in data){
            formData.append(data[key]['name'], data[key]['value']);
        }

        if(form.find('input[type="file"]').val()){
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function( response ){
                preloader(form, false);
                form.find('.success-alert').removeClass('d-none');

                $('.user-name').html($('input[name="name"]').val())
            },
            error: function( responseError){
                displayFormError(form, responseError)
            }
        });
    })

    // Update password
    $('.profile-update-password-form').on('submit', function(e){
        e.preventDefault();

        let form = $(this);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: form.serialize(),
            success: function( response ){
                preloader(form, false);
                form.trigger('reset');
                form.find('.success-alert').removeClass('d-none');
            },
            error: function( responseError){
                displayFormError(form, responseError)
            }
        });
    })

    // TinyMce
    if(window.enableTinyMce !== undefined){
        tinymce.init({
            menubar: false,
            selector:'textarea.richTextBox',
            skin: 'voyager',
            min_height: 350,
            branding: false,
            resize: 'vertical',
            plugins: 'autolink, lists, link, image, paste, code, youtube, giphy, table, textcolor',
            extended_valid_elements : 'input[id|name|value|type|class|style|required|placeholder|autocomplete|onclick]',
            relative_urls: false,
            paste_data_images: true,
            toolbar: 'styleselect | bold italic underline | alignleft aligncenter alignright | bullist numlist outdent inden',
            style_formats: [
                {title: 'Title', format: 'h4'},
                {title: 'Text', block: 'p'}
            ],
            setup : function(editor) {
                editor.on('change keyup', function () {
                    tinymce.triggerSave();
                });
            }
        });
    }

    // Update bio
    $('.profile-update-bio-form').on('submit', function(e){
        e.preventDefault();

        let form = $(this);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        let data = form.serializeArray();

        var formData = new FormData();

        for(let key in data){
            formData.append(data[key]['name'], data[key]['value']);
        }

        if(form.find('input[type="file"]').val()){
            formData.append('file', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function( response ){
                preloader(form, false);

                form.find('.cv-path').attr('href', response.cv.path);
                form.find('.cv-name').html(response.cv.name);
                form.find('input[type="file"]').val('');
                form.find('.success-alert').removeClass('d-none');
            },
            error: function( responseError){
                displayFormError(form, responseError)
            }
        });
    })

    // Work form-create Popup
    $('.open-popup-link').magnificPopup({
        type:'inline',
        midClick: true
    });

    // Work form-edit Popup
    function workFormEditPopup(){
        $('.open-popup-link-edit').magnificPopup({
            type:'inline',
            midClick: true,
            callbacks: {
                open: function() {
                    // Get form and insert in popup container
                    $.get(this.st.el.data('url'), function( response ) {
                        $('#work-edit-form-popup').html(response.view);
                        uploadImageEvent();
                    });
                },
                close: function() {
                    // Clean popup container
                    $('#work-edit-form-popup').html('');
                }
            }
        });
    }

    workFormEditPopup();

    // Work store/update API
    $(document).on('submit', '.profile-save-work-form', function(e){
        e.preventDefault();

        let form = $(this);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');

        let data = form.serializeArray();

        var formData = new FormData();

        for(let key in data){
            formData.append(data[key]['name'], data[key]['value']);
        }

        if(form.find('input[type="file"]').val()){
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function( response ){
                $('.member-works .isotope-grid-wrapper').html(response.view);

                setTimeout(function(){
                    preloader(form, false);

                    form.find('input[type="file"]').val('');
                    window.isotopeGridInit();

                    workFormEditPopup();

                    $.magnificPopup.close();

                    form.find('#img-uploaded').attr('src', '/img/placeholder.jpg');
                    form.trigger('reset');
                }, 400);
            },
            error: function( responseError){
                displayFormError(form, responseError)
            }
        });
    })

    // Work delete API
    $(document).on('click', '.delete-work', function(e){
        e.preventDefault();
        if(confirm('Are you sure?')){
            let form = $('.profile-save-work-form');

            preloader(form, true);

            $.ajax({
                url: $(this).data('url'),
                dataType: 'json',
                type: 'post',
                success: function( response ){
                    $('.member-works .isotope-grid-wrapper').html(response.view);

                    setTimeout(function(){
                        preloader(form, false);
                        window.isotopeGridInit();

                        workFormEditPopup();

                        $.magnificPopup.close();
                    }, 400);
                },
                error: function( responseError){
                    displayFormError(form, responseError)
                }
            });
        }
    });


    // Upload button
    var SITE = SITE || {};

    SITE.fileInputs = function() {
        var $this = $(this),
            $val = $this.val(),
            valArray = $val.split('\\'),
            newVal = valArray[valArray.length-1],
            $button = $this.siblings('.btn'),
            $fakeFile = $this.siblings('.file-holder');
        if(newVal !== '') {
            $button.text('Photo Chosen');
            if($fakeFile.length === 0) {
                $button.after('<span class="file-holder">' + newVal + '</span>');
            } else {
                $fakeFile.text(newVal);
            }
        }
    };

    $('.file-wrapper input[type=file]').bind('change focus click', SITE.fileInputs);

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var tmppath = URL.createObjectURL(input.files[0]);

            reader.onload = function (e) {
                $('#img-uploaded').attr('src', tmppath);
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    function uploadImageEvent(){
        $(".uploader").change(function(){
            readURL(this);
        });
    }

    uploadImageEvent();

}

export default profile;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/profile.js